import { Checkbox, Divider, ListItemText, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BtnOutlined, CmbWithTitle, Column, ContainerInside, ItemContainer, Items, LabelItem, ValueItem } from "../styled.components";


import FooterBtns from "../FooterBtns";
import { cloneObjectWithRegExp, hotToast, validateData } from "utils";
import Inputs, { InputsGroup } from "Components/Inputs";
import { InputModal, SelectMultiple } from "Components/V1/InputModal";
import IColumnas from "ITables/Columnas";
import Table from "Components/V1/Table";
import SaveIcon from "@mui/icons-material/Save";
import ServiceArchivo from "service/archivos";
import { ContainerTOperaciones, TableRelacionMT } from "./styled.components";


interface ITipoOperacion {
    checked: boolean;
    codigoTipoOperacion: string;
    idTipoOperacion: number;
    tipoOperacion: string;
}

interface IRelacion {
    codigoMarca: string;
    idMarca: number;
    marca: string;
    tiposOperacion: Array<ITipoOperacion>
}
interface IDataRel {
    idMarca: number;
    idTipoOperacion: number;
}

const ConfiguracionMT = ({ reloadData, closeModal, loading, setLoading, row }: any) => {
    const [arrayRelacion, setArrayRelacion] = useState<Array<IRelacion>>([])
    const [dataRel, setDataRel] = useState<Array<IDataRel>>([])

    useEffect(() => {
        if (row) {
            getAll();
        }
    }, [row])

    const getAll = async() => {
        const data:Array<IRelacion> = await ServiceArchivo.getRelMarcaOperacion(setArrayRelacion, row.idArchivo);

        let response:Array<IDataRel> = [];
        data.map((marca:IRelacion)=> {
            marca.tiposOperacion.map((operacion:ITipoOperacion)=> {
                if(operacion.checked){
                    response.push({idMarca:marca.idMarca,idTipoOperacion:operacion.idTipoOperacion})
                }
            })
        })
        setDataRel(response);
    }

    const handleChange = (request: IDataRel, checked: boolean) => {
        let data: Array<IDataRel> = [...dataRel];
        let dataResponse: Array<IRelacion> = [...arrayRelacion];

        if (checked) {
            setDataRel((old: Array<IDataRel>) => [...old, request])
        } else {
            const index = data.findIndex((d) => d.idMarca === request.idMarca && d.idTipoOperacion === request.idTipoOperacion);
            data.splice(index, 1)
            setDataRel([...data]);
        }

        const _marca = dataResponse.findIndex((d: IRelacion) => d.idMarca === request.idMarca)
        const _operacion = dataResponse[_marca].tiposOperacion.findIndex((a: ITipoOperacion) => a.idTipoOperacion === request.idTipoOperacion)
        dataResponse[_marca].tiposOperacion[_operacion].checked = checked;
        setArrayRelacion([...dataResponse])
    }

    const onSubmit = async () => {
        setLoading(true);

        let response = await ServiceArchivo.updateRelMarcaOperacion(dataRel, row.idArchivo);
        if (response) {
            hotToast("El registro se guardo correctamente", "SUCCESS");
            reloadData && reloadData();
            closeModal && closeModal();
        }
        setLoading(false);

    };

    return (
        <ContainerInside>
            <InputsGroup jC="space-around">
                <ItemContainer>
                    <LabelItem>Nombre del archivo:</LabelItem>
                    <ValueItem>{row.nombreArchivo}</ValueItem>
                </ItemContainer>
                <ItemContainer>
                    <LabelItem>Prefijo:</LabelItem>
                    <ValueItem>{row.prefijo}</ValueItem>
                </ItemContainer>
            </InputsGroup>


            <TableRelacionMT>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Marca</th>
                        <th>Tipo Operación</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayRelacion.map((marca: IRelacion, index: number) => (
                        <tr key={index}>
                            <td>{marca.idMarca}</td>
                            <td>{marca.marca}</td>
                            <td>
                                {marca.tiposOperacion.map((operacion: ITipoOperacion, index: number) => (
                                    <ContainerTOperaciones key={index}>
                                        <div>{operacion.tipoOperacion}</div>
                                        <Checkbox onChange={(e: any) => handleChange({ idMarca: marca.idMarca, idTipoOperacion: operacion.idTipoOperacion }, e.target.checked)} checked={operacion.checked} />
                                    </ContainerTOperaciones>
                                ))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </TableRelacionMT>

            <FooterBtns
                handleCancel={closeModal}
                handleSubmit={onSubmit}
                loader={loading}
            />
        </ContainerInside >
    );
};

export default ConfiguracionMT;
